import { TrackEvent } from 'contexts/analytics/types';
import { PartnerNotesData } from 'store/partnerNotes';
import styles from '../Sidebar.module.css';
import { SidebarItemConfig } from '../useSidebarItems';

export function getMobilePartnersRecsItems(
  partnerNotes: PartnerNotesData[string][],
  trackEvent: TrackEvent,
): SidebarItemConfig[] {
  return partnerNotes.map(pN => ({
    label: `${pN.partner.name} Recs`,
    icon: 'thumbStar',
    to: `/partner-recs/${pN.partner.id}`,
    customClassName: styles.partnerRecsIcon,
    onClick: () => trackEvent('Partner Recs Nav Clicked'),
  }));
}
